import { css } from 'styled-components';
export var applyScrollSnap = function applyScrollSnap(_ref) {
  var scrollSnapAlign = _ref.scrollSnapAlign;
  return scrollSnapAlign && css(["scroll-snap-align:", ";"], scrollSnapAlign);
};